import { CategoryID } from '@sbt-web/network/types';
import { morphism } from 'morphism';

const macroToVerticalMap = {
    [CategoryID.Tutte]: 'subito',
    [CategoryID.Motori]: 'motors',
    [CategoryID.Immobili]: 'realestate',
    [CategoryID.LavoroServizi]: 'jobs',
    [CategoryID.Elettronica]: 'market',
    [CategoryID.CasaPersona]: 'market',
    [CategoryID.SportsHobby]: 'market',
    [CategoryID.Altri]: 'market',
};
// This category doesn't exist in the backend but we need it here to generate the filters ui
const category0 = {
    identifier: '0',
    friendly_name: 'usato',
    label: 'Tutte le categorie',
    sorting_list: ['datedesc', 'relevance', 'priceasc', 'pricedesc'],
    default_ad_type: 's',
    ad_types: ['s', 'g', 'u', 'h', 'k'],
    categories: [],
};
// These categories are generated from an Anubi response using this script https://github.mpi-internal.com/SCM-Italy/SearchConfigurationResources
const generatedCategories = {
    macrocategories: [
        {
            identifier: '1',
            friendly_name: 'motori',
            label: 'MOTORI',
            sorting_list: ['datedesc', 'priceasc', 'pricedesc'],
            default_ad_type: 's',
            ad_types: ['s', 'k'],
            categories: [
                {
                    identifier: '2',
                    friendly_name: 'auto',
                    label: 'Auto',
                    default_ad_type: 's',
                    ad_types: ['s', 'k'],
                    sorting_list: [
                        'datedesc',
                        'relevance',
                        'priceasc',
                        'pricedesc',
                        'yearasc',
                        'yeardesc',
                        'mileageasc',
                        'mileagedesc',
                    ],
                },
                {
                    identifier: '5',
                    friendly_name: 'accessori-auto',
                    label: 'Accessori Auto',
                    default_ad_type: 's',
                    ad_types: ['s', 'k'],
                    sorting_list: ['datedesc', 'relevance', 'priceasc', 'pricedesc'],
                },
                {
                    identifier: '3',
                    friendly_name: 'moto-e-scooter',
                    label: 'Moto e Scooter',
                    default_ad_type: 's',
                    ad_types: ['s', 'k'],
                    sorting_list: [
                        'datedesc',
                        'relevance',
                        'priceasc',
                        'pricedesc',
                        'yearasc',
                        'yeardesc',
                        'mileageasc',
                        'mileagedesc',
                    ],
                },
                {
                    identifier: '36',
                    friendly_name: 'accessori-moto',
                    label: 'Accessori Moto',
                    default_ad_type: 's',
                    ad_types: ['s', 'k'],
                    sorting_list: ['datedesc', 'relevance', 'priceasc', 'pricedesc'],
                },
                {
                    identifier: '22',
                    friendly_name: 'nautica',
                    label: 'Nautica',
                    default_ad_type: 's',
                    ad_types: ['s', 'k', 'u'],
                    sorting_list: ['datedesc', 'relevance', 'priceasc', 'pricedesc'],
                },
                {
                    identifier: '34',
                    friendly_name: 'caravan-e-camper',
                    label: 'Caravan e Camper',
                    default_ad_type: 's',
                    ad_types: ['s', 'k', 'u'],
                    sorting_list: ['datedesc', 'relevance', 'priceasc', 'pricedesc'],
                },
                {
                    identifier: '4',
                    friendly_name: 'veicoli-commerciali',
                    label: 'Veicoli commerciali',
                    default_ad_type: 's',
                    ad_types: ['s', 'k'],
                    sorting_list: ['datedesc', 'relevance', 'priceasc', 'pricedesc'],
                },
            ],
        },
        {
            identifier: '6',
            friendly_name: 'immobili',
            label: 'IMMOBILI',
            sorting_list: ['datedesc', 'priceasc', 'pricedesc'],
            default_ad_type: 's',
            ad_types: ['s', 'k', 'u', 'h'],
            categories: [
                {
                    identifier: '7',
                    friendly_name: 'appartamenti',
                    label: 'Appartamenti',
                    default_ad_type: 's',
                    ad_types: ['s', 'k', 'u'],
                    sorting_list: ['datedesc', 'relevance', 'priceasc', 'pricedesc'],
                    supports_city_zones: true,
                },
                {
                    identifier: '43',
                    friendly_name: 'camere-posti-letto',
                    label: 'Camere/Posti letto',
                    default_ad_type: 'u',
                    ad_types: ['k', 'u'],
                    sorting_list: ['datedesc', 'relevance', 'priceasc', 'pricedesc'],
                    supports_city_zones: true,
                },
                {
                    identifier: '29',
                    friendly_name: 'ville-singole-e-a-schiera',
                    label: 'Ville singole e a schiera',
                    default_ad_type: 's',
                    ad_types: ['s', 'k', 'u'],
                    sorting_list: ['datedesc', 'relevance', 'priceasc', 'pricedesc'],
                    supports_city_zones: true,
                },
                {
                    identifier: '30',
                    friendly_name: 'terreni-e-rustici',
                    label: 'Terreni e rustici',
                    default_ad_type: 's',
                    ad_types: ['s', 'k', 'u'],
                    sorting_list: ['datedesc', 'relevance', 'priceasc', 'pricedesc'],
                    supports_city_zones: true,
                },
                {
                    identifier: '31',
                    friendly_name: 'garage-e-box',
                    label: 'Garage e box',
                    default_ad_type: 's',
                    ad_types: ['s', 'k', 'u'],
                    sorting_list: ['datedesc', 'relevance', 'priceasc', 'pricedesc'],
                    supports_city_zones: true,
                },
                {
                    identifier: '32',
                    friendly_name: 'loft-mansarde',
                    label: 'Loft, mansarde e altro',
                    default_ad_type: 's',
                    ad_types: ['s', 'k', 'u'],
                    sorting_list: ['datedesc', 'relevance', 'priceasc', 'pricedesc'],
                    supports_city_zones: true,
                },
                {
                    identifier: '33',
                    friendly_name: 'case-vacanza',
                    label: 'Case vacanza',
                    default_ad_type: 'h',
                    ad_types: ['k', 'h'],
                    sorting_list: ['datedesc', 'relevance', 'priceasc', 'pricedesc'],
                    supports_city_zones: true,
                },
                {
                    identifier: '8',
                    friendly_name: 'uffici-locali-commerciali',
                    label: 'Uffici e Locali commerciali',
                    default_ad_type: 's',
                    ad_types: ['s', 'k', 'u'],
                    sorting_list: ['datedesc', 'relevance', 'priceasc', 'pricedesc'],
                    supports_city_zones: true,
                },
            ],
        },
        {
            identifier: '24',
            friendly_name: 'lavoro',
            label: 'LAVORO E SERVIZI',
            sorting_list: ['datedesc', 'priceasc', 'pricedesc'],
            default_ad_type: 's',
            ad_types: ['s'],
            categories: [
                {
                    identifier: '26',
                    friendly_name: 'offerte-lavoro',
                    label: 'Offerte di lavoro',
                    default_ad_type: 's',
                    ad_types: ['s'],
                    sorting_list: ['datedesc', 'relevance', 'priceasc', 'pricedesc'],
                },
                {
                    identifier: '50',
                    friendly_name: 'servizi',
                    label: 'Servizi',
                    default_ad_type: 's',
                    ad_types: ['s'],
                    sorting_list: ['datedesc', 'relevance', 'priceasc', 'pricedesc'],
                },
                {
                    identifier: '42',
                    friendly_name: 'cerco-lavoro',
                    label: 'Candidati in cerca di lavoro',
                    default_ad_type: 's',
                    ad_types: ['s'],
                    sorting_list: ['datedesc', 'relevance', 'priceasc', 'pricedesc'],
                },
                {
                    identifier: '25',
                    friendly_name: 'attrezzature',
                    label: 'Attrezzature di lavoro',
                    default_ad_type: 's',
                    ad_types: ['s', 'k'],
                    sorting_list: ['datedesc', 'relevance', 'priceasc', 'pricedesc'],
                },
            ],
        },
        {
            identifier: '9',
            friendly_name: 'elettronica',
            label: 'ELETTRONICA',
            sorting_list: ['datedesc', 'priceasc', 'pricedesc'],
            default_ad_type: 's',
            ad_types: ['s', 'g', 'k'],
            categories: [
                {
                    identifier: '10',
                    friendly_name: 'informatica',
                    label: 'Informatica',
                    default_ad_type: 's',
                    ad_types: ['s', 'g', 'k'],
                    sorting_list: ['relevance', 'datedesc', 'priceasc', 'pricedesc'],
                },
                {
                    identifier: '44',
                    friendly_name: 'videogiochi',
                    label: 'Console e Videogiochi',
                    default_ad_type: 's',
                    ad_types: ['s', 'g', 'k'],
                    sorting_list: ['relevance', 'datedesc', 'priceasc', 'pricedesc'],
                },
                {
                    identifier: '11',
                    friendly_name: 'audio-video',
                    label: 'Audio/Video',
                    default_ad_type: 's',
                    ad_types: ['s', 'g', 'k'],
                    sorting_list: ['relevance', 'datedesc', 'priceasc', 'pricedesc'],
                },
                {
                    identifier: '40',
                    friendly_name: 'fotografia',
                    label: 'Fotografia',
                    default_ad_type: 's',
                    ad_types: ['s', 'g', 'k'],
                    sorting_list: ['relevance', 'datedesc', 'priceasc', 'pricedesc'],
                },
                {
                    identifier: '12',
                    friendly_name: 'telefonia',
                    label: 'Telefonia',
                    default_ad_type: 's',
                    ad_types: ['s', 'g', 'k'],
                    sorting_list: ['relevance', 'datedesc', 'priceasc', 'pricedesc'],
                },
            ],
        },
        {
            identifier: '13',
            friendly_name: 'casa-e-persona',
            label: 'PER LA CASA e LA PERSONA',
            sorting_list: ['datedesc', 'priceasc', 'pricedesc'],
            default_ad_type: 's',
            ad_types: ['s', 'g', 'k'],
            categories: [
                {
                    identifier: '14',
                    friendly_name: 'arredamento-casalinghi',
                    label: 'Arredamento e Casalinghi',
                    default_ad_type: 's',
                    ad_types: ['s', 'g', 'k'],
                    sorting_list: ['relevance', 'datedesc', 'priceasc', 'pricedesc'],
                },
                {
                    identifier: '37',
                    friendly_name: 'elettrodomestici',
                    label: 'Elettrodomestici',
                    default_ad_type: 's',
                    ad_types: ['s', 'g', 'k'],
                    sorting_list: ['relevance', 'datedesc', 'priceasc', 'pricedesc'],
                },
                {
                    identifier: '15',
                    friendly_name: 'giardino-fai-da-te',
                    label: 'Giardino e Fai da te',
                    default_ad_type: 's',
                    ad_types: ['s', 'g', 'k'],
                    sorting_list: ['relevance', 'datedesc', 'priceasc', 'pricedesc'],
                },
                {
                    identifier: '16',
                    friendly_name: 'abbigliamento-accessori',
                    label: 'Abbigliamento e Accessori',
                    default_ad_type: 's',
                    ad_types: ['s', 'g', 'k'],
                    sorting_list: ['relevance', 'datedesc', 'priceasc', 'pricedesc'],
                },
                {
                    identifier: '17',
                    friendly_name: 'bambini-giocattoli',
                    label: 'Tutto per i bambini',
                    default_ad_type: 's',
                    ad_types: ['s', 'g', 'k'],
                    sorting_list: ['relevance', 'datedesc', 'priceasc', 'pricedesc'],
                },
            ],
        },
        {
            identifier: '18',
            friendly_name: 'sport-hobby',
            label: 'SPORTS E HOBBY',
            sorting_list: ['datedesc', 'priceasc', 'pricedesc'],
            default_ad_type: 's',
            ad_types: ['s', 'g', 'k'],
            categories: [
                {
                    identifier: '23',
                    friendly_name: 'animali',
                    label: 'Animali',
                    default_ad_type: 's',
                    ad_types: ['s', 'g', 'k'],
                    sorting_list: ['relevance', 'datedesc', 'priceasc', 'pricedesc'],
                },
                {
                    identifier: '100',
                    friendly_name: 'accessori-per-animali',
                    label: 'Accessori per animali',
                    default_ad_type: 's',
                    ad_types: ['s', 'g'],
                    sorting_list: ['relevance', 'datedesc', 'priceasc', 'pricedesc'],
                },
                {
                    identifier: '19',
                    friendly_name: 'musica-film',
                    label: 'Musica e Film',
                    default_ad_type: 's',
                    ad_types: ['s', 'g', 'k'],
                    sorting_list: ['relevance', 'datedesc', 'priceasc', 'pricedesc'],
                },
                {
                    identifier: '38',
                    friendly_name: 'libri-riviste',
                    label: 'Libri e Riviste',
                    default_ad_type: 's',
                    ad_types: ['s', 'g', 'k'],
                    sorting_list: ['relevance', 'datedesc', 'priceasc', 'pricedesc'],
                },
                {
                    identifier: '39',
                    friendly_name: 'strumenti-musicali',
                    label: 'Strumenti Musicali',
                    default_ad_type: 's',
                    ad_types: ['s', 'g', 'k'],
                    sorting_list: ['relevance', 'datedesc', 'priceasc', 'pricedesc'],
                },
                {
                    identifier: '20',
                    friendly_name: 'sport',
                    label: 'Sports',
                    default_ad_type: 's',
                    ad_types: ['s', 'g', 'k'],
                    sorting_list: ['relevance', 'datedesc', 'priceasc', 'pricedesc'],
                },
                {
                    identifier: '41',
                    friendly_name: 'biciclette',
                    label: 'Biciclette',
                    default_ad_type: 's',
                    ad_types: ['s', 'g', 'k'],
                    sorting_list: ['relevance', 'datedesc', 'priceasc', 'pricedesc'],
                },
                {
                    identifier: '21',
                    friendly_name: 'hobby-collezionismo',
                    label: 'Collezionismo',
                    default_ad_type: 's',
                    ad_types: ['s', 'g', 'k'],
                    sorting_list: ['relevance', 'datedesc', 'priceasc', 'pricedesc'],
                },
            ],
        },
        {
            identifier: '27',
            friendly_name: 'vari',
            label: '--',
            sorting_list: ['datedesc', 'priceasc', 'pricedesc'],
            default_ad_type: 's',
            ad_types: ['s', 'g', 'k'],
            categories: [
                {
                    identifier: '28',
                    friendly_name: 'annunci-vari',
                    label: 'Altri',
                    default_ad_type: 's',
                    ad_types: ['s', 'g', 'k'],
                    sorting_list: ['datedesc', 'relevance', 'priceasc', 'pricedesc'],
                },
            ],
        },
    ],
};
const allCategories = [category0, ...generatedCategories.macrocategories];
const categorySchema = {
    id: 'identifier',
    label: 'label',
    friendly: 'friendly_name',
    orders: 'sorting_list',
    adTypes: 'ad_types',
    defaultAdType: 'default_ad_type',
    zoneSupport: 'supports_city_zones',
};
const macroCategorySchema = {
    id: 'identifier',
    label: 'label',
    friendly: 'friendly_name',
    orders: 'sorting_list',
    adTypes: 'ad_types',
    defaultAdType: 'default_ad_type',
    categories: {
        path: 'categories',
        fn: morphism(categorySchema),
    },
};
const CategoryAll = morphism(macroCategorySchema, category0);
const CategoryStore = allCategories.map(morphism(macroCategorySchema));

/**
 * Type-guard to identify if a Category is a MacroCategory
 * @param cat The category which type you want stricter
 * @returns A boolean telling you if the category is a macro
 */
const isMacroCategory = (cat) => CategoryStore.some((c) => c.id === cat.id);
/**
 * Type-guard to identify if a Category is a LeafCategory
 * @param cat The category which type you want stricter
 * @returns A boolean telling you if the category is a leaf
 */
const isLeafCategory = (cat) => CategoryStore.some((macro) => macro.categories.some((c) => c.id === cat.id));
/**
 * Returns an array of all macro categories
 * @returns an array that contains all macro categories.
 */
const getAllMacroCategories = () => CategoryStore;
/**
 * Returns a flat array of all macro and leaf categories
 * @returns an array that contains all categories. Macro and leaf categories are mixed together
 */
const getAllCategories = () => CategoryStore.reduce((list, cat) => list.concat(cat).concat(cat.categories), []);
/**
 * Finds a category by its ID.
 * @param id The ID of a category
 * @returns The category corresponding to the ID, can be either a Macro or Leaf category, otherwise returns 0 or "Tutte le categorie"
 */
const getCategoryByID = (id) => {
    for (const macro of CategoryStore) {
        if (macro.id === id)
            return macro;
        for (const leaf of macro.categories) {
            if (leaf.id === id)
                return leaf;
        }
    }
    return CategoryAll;
};
/**
 * Finds the macro category of a generic category
 * @param id The ID to get the MacroCategory from
 * @returns The Macro of the current category, which might be itself, otherwise returns 0 or "Tutte le categorie".
 */
const getMacroOfCategoryID = (id) => {
    for (const macro of CategoryStore) {
        if (macro.id === id)
            return macro;
        for (const leaf of macro.categories) {
            if (leaf.id === id)
                return macro;
        }
    }
    return CategoryAll;
};
/**
 * Find the vertical of a generic category
 * @param id The ID to get the Vertical from
 * @returns The Vertical of the current category, otherwise returns "subito" as default.
 */
const getVerticalOfCategoryID = (id) => macroToVerticalMap[getMacroOfCategoryID(id).id];
/**
 * Finds a category by its friendlyName.
 * @param name The friendlyName of the macro category to search
 * @returns The category corresponding to the friendlyName, can be either a Macro or Leaf category, otherwise returns 0 or "Tutte le categorie"
 */
const getCategoryByFriendly = (name) => {
    for (const macro of CategoryStore) {
        if (macro.friendly === name)
            return macro;
        for (const leaf of macro.categories) {
            if (leaf.friendly === name)
                return leaf;
        }
    }
    return CategoryAll;
};
/**
 * Find the Category label by its ID
 * @param id The ID of a category
 * @returns The label corresponding to the ID, if not found returns "Tutte le categorie"
 */
const getCategoryLabelByID = (id) => getCategoryByID(id).label;
/**
 * Find the Category friendlyName by its ID
 * @param id The ID of a category
 * @returns The friendlyName corresponding to the ID, if not found returns "usato"
 */
const getCategoryFriendlyNameByID = (id) => getCategoryByID(id).friendly;
const marketMacrocategories = [
    CategoryID.Elettronica,
    CategoryID.CasaPersona,
    CategoryID.SportsHobby,
    CategoryID.Altri,
];
const isShippableCategory = (catID) => {
    const id = catID;
    if (id === CategoryID.Animali) {
        return false;
    }
    else if (id === CategoryID.Tutte ||
        id === CategoryID.AccessoriAuto ||
        id === CategoryID.AccessoriMoto) {
        return true;
    }
    else if (isMacroCategory(getCategoryByID(id))) {
        return marketMacrocategories.includes(id);
    }
    else {
        return marketMacrocategories.includes(getMacroOfCategoryID(id).id);
    }
};

export { getAllCategories, getAllMacroCategories, getCategoryByFriendly, getCategoryByID, getCategoryFriendlyNameByID, getCategoryLabelByID, getMacroOfCategoryID, getVerticalOfCategoryID, isLeafCategory, isMacroCategory, isShippableCategory };
//# sourceMappingURL=index.js.map
